import { Expose, Type } from "../../../serialization/class-transformer/decorators";
import { ZoomIdentity } from "../zoom.identity";

export class PinZoomToDashboardDto {
    
    @Expose()
    @Type(() => ZoomIdentity)
    zoomIdentity: ZoomIdentity;
}